module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header header4"
  }, [_c('div', {
    staticClass: "header-main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clear1"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('button', {
    staticClass: "header-but1",
    staticStyle: {
      "margin-top": "5%",
      "color": "#000"
    },
    attrs: {
      "id": "header-but1"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('newyearactivityrule')
      }
    }
  }, [_vm._v("活动详情\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "header-footer",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("新用户*赢现金红包，推荐人得现金奖励")])]), _vm._v(" "), _c('div', {
    staticClass: "header-icon1"
  })]), _vm._v(" "), (_vm.hasRedPackage) ? _c('div', {
    staticClass: "main1"
  }, [(_vm.packageList.ty.used === false) ? _c('button', {
    staticClass: "main1-but1",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop/cate/8')
      }
    }
  }, [_c('b', {
    staticStyle: {
      "font-size": "50%"
    }
  }, [_vm._v("未使用")]), _c('br'), _vm._v(_vm._s(_vm.packageList.ty.amount) + " 元 "), _c('br'), _c('b', {
    staticStyle: {
      "font-size": "80%"
    }
  }, [_vm._v("体验装")])]) : _c('button', {
    staticClass: "main1-but1",
    staticStyle: {
      "color": "gray",
      "border-color": "gray"
    }
  }, [_c('b', {
    staticStyle: {
      "font-size": "50%"
    }
  }, [_vm._v("已使用")]), _c('br'), _vm._v(_vm._s(_vm.packageList.ty.amount) + "\n            元 "), _c('br'), _c('b', {
    staticStyle: {
      "font-size": "80%"
    }
  }, [_vm._v("体验装")])]), _vm._v(" "), (_vm.packageList.ty.used === true && _vm.packageList.zz.used === false) ? _c('button', {
    staticClass: "main1-but2",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop/cate/6')
      }
    }
  }, [_c('b', {
    staticStyle: {
      "font-size": "50%"
    }
  }, [_vm._v("未使用")]), _c('br'), _vm._v(_vm._s(_vm.packageList.zz.amount) + "\n            元 "), _c('br'), _c('b', {
    staticStyle: {
      "font-size": "80%"
    }
  }, [_vm._v("正装护眼水")])]) : _vm._e(), _vm._v(" "), (_vm.packageList.ty.used === true && _vm.packageList.zz.used === true) ? _c('button', {
    staticClass: "main1-but2",
    staticStyle: {
      "color": "gray",
      "border-color": "gray"
    }
  }, [_c('b', {
    staticStyle: {
      "font-size": "50%"
    }
  }, [_vm._v("已使用")]), _c('br'), _vm._v(_vm._s(_vm.packageList.zz.amount) + "\n            元 "), _c('br'), _c('b', {
    staticStyle: {
      "font-size": "80%"
    }
  }, [_vm._v("正装护眼水")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear1"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer4"
  }, [_vm._v("*新用户：新关注或未购买过产品的用户。")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-left"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "15px",
      "color": "#000"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "#09bb07"
    }
  }, [_vm._v("有奖 ")]), _vm._v("传播生态护眼的爱心")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "15px",
      "color": "#000"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "#09bb07"
    }
  }, [_vm._v("免费 ")]), _vm._v("体验改变视界的感受")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fba0e8a8"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/newYearActivity/mypackage.vue
// module id = 740
// module chunks = 0